function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "221.001,230.957 26.868,0 8.956,0 217.124,247.652 512,247.652 512,230.957 "
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "8.956,512 26.868,512 221.001,281.043 512,281.043 512,264.348 217.124,264.348 "
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "0,10.655 0,31.964 188.317,256 0,480.036 0,501.345 206.229,256 "
});

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

function Svg148Vanuatu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "512,256 512,512 0,512 215.185,256 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "512,0 512,256 215.185,256 0,0 "
  }), _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "8.956,0 0,0 0,10.655 206.229,256 0,501.345 0,512 8.956,512 217.124,264.348 512,264.348    512,247.652 217.124,247.652  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M55.76,320v-25.147c25.095,0,45.509-20.417,45.509-45.509c0-17.754-14.444-32.198-32.198-32.198   c-12.094,0-21.935,9.839-21.935,21.936c0,7.733,6.292,14.027,14.028,14.027c4.372,0,7.929-3.56,7.929-7.93h25.146   c0,18.239-14.838,33.077-33.075,33.077c-21.602,0-39.174-17.574-39.174-39.174c0-25.962,21.121-47.083,47.081-47.083   c31.619,0,57.345,25.725,57.345,57.345C126.416,288.303,94.72,320,55.76,320z"
  })), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg148Vanuatu);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };